<template>
  <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      title="发料确认"
      width="1000px"
      top="1vh"
      @close="reserveOrder = reserveOrderBackup">
    <div>
      <div class="title" style="margin:0 0 5px">基本信息</div>
      <table cellspacing="0" cellpadding="0" class="ReserveOrderTable" style="width: 100%">
        <tr>
          <td class="tableLabel">预留单号</td>
          <td class="tableContent">{{reserveOrder.reservNo}}</td>
          <td class="tableLabel">领料人</td>
          <td class="tableContent">{{reserveOrder.gr_RCPT}}</td>
        </tr>
        <tr>
          <td class="tableLabel">移动类型</td>
          <td class="tableContent">{{reserveOrder.orderMoveType}}</td>
          <td class="tableLabel">移动类型描述</td>
          <td class="tableContent">{{reserveOrder.orderMoveTypeDesc}}</td>
        </tr>
        <tr>
          <td class="tableLabel">需求日期</td>
          <td class="tableContent">{{reserveOrder.plnOutDate}}</td>
          <td class="tableLabel">内部订单号</td>
          <td class="tableContent">{{reserveOrder.orderId}}</td>
        </tr>
      </table>
      <div class="title">预留单明细</div>
      <el-table
          ref="elTable"
          :data="reserveOrder.detailList"
          border>
        <el-table-column prop="resItem" align="center" label="行号" width="60"/>
        <el-table-column prop="material" align="center" label="物料号" width="100"/>
        <el-table-column prop="matlDesc" label="物料描述" show-overflow-tooltip/>
        <el-table-column prop="entryUom" align="center" label="条目单位" width="80"/>
        <el-table-column prop="reqQuan" align="center" label="需求量" width="70"/>
        <el-table-column prop="stgeLoc" align="center" label="发料仓库" width="90"/>
        <el-table-column prop="shkzg" align="center" label="借/贷标识" width="80"/>
        <el-table-column prop="sapDelete" align="center" label="删除标记" width="80">
          <template slot-scope="scope">
            <el-tag type="danger" v-if="scope.row.sapDelete === true">已删除</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sendQty" align="center" label="实发数量" width="80">
          <template v-slot="scope">
            <el-input
                v-model="scope.row.sendQty"
                :disabled="scope.row.sendQty===scope.row.reqQuan || scope.row.sapDelete === true"
                @input="limitSendQtyInput(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            align="center"
            width="100"
            fixed="right">
          <template v-slot="scope">
            <el-button :disabled="scope.row.sapDelete === true" type="danger" @click="deleteOne(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>

  export default {
    name: "ReserveOrderEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        reserveOrderBackup: {},
        reserveOrder: {
          id: "",
          status: "",
          printCount: "",
          createTime: "",
          updateId: "",
          updateName: "",
          updateTime: "",
          plant: "",
          creatorName: "",
          creatorDate: "",
          plnOutDate: "",
          reservNo: "",
          costcenter: "",
          orderId: "",
          gr_RCPT: "",
          rcptid: "",
          statusDesc: "",
          postingStatusDesc: "",
          orderMoveTypeDesc: "",
          plnOutDateDesc: "",
          detailList: [],
        },
      };
    },
    methods: {
      open(id) {
        this.reserveOrder.id = id;
        if (id > 0) {
          this.getData(id);
        }
        this.reserveOrderBackup = JSON.parse(JSON.stringify(this.reserveOrder));
        this.dialogVisible = true;
      },
      getData(id) {
        this.contentLoading = true;
        this.$http.get("basic", `reserveOrders/${id}`).then(res => {
          this.reserveOrder = res;
        }).finally(() => {
          this.contentLoading = false;
        });
      },
      handleSubmit() {
        this.submitLoading = true;
        this.$http
          .post("basic", "reserveOrders/confirm", this.reserveOrder)
          .then(() => {
            this.$emit("save-success");
            this.$message.success("过账成功");
            this.dialogVisible = false;
          })
          .finally(() => {
            this.submitLoading = false;
          });
      },
      limitSendQtyInput(row) {
        row.sendQty = ("" + row.sendQty)
          .replace(/[^\d^.]+/g, "")
          .replace(/^0+(\d)/, "$1")
          .replace(/^\./, "0.")
          .match(/^\d*(\.?\d{0,2})/g)[0] || "";
      },

      deleteOne(row) {
        this.$http.get("basic",`reserveOrders/deleteRow/${this.reserveOrder.reservNo}/${row.resItem}/${row.id}`)
          .then(()=>{
            row.sapDelete=true;
          }).catch((resp)=>{
            this.$message.error(resp);
          });
      },

    },
  };
</script>
<style lang="scss" scoped>
.ReserveOrderTable {
  font-family: verdana, arial, sans-serif;
  font-size: 13px;
  color: #333333;
  border-left: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
}

.ReserveOrderTable td {
  padding: 5px;
  border-right: 1px solid #dddddd;
  border-top: 1px solid #dddddd;
}

.title {
  font-size: 16px;
  border-bottom: 1px solid #ccc;
  width: 100%;
  margin: 10px 0 5px;
}

.tableLabel {
  width: 20%;
  text-align: right;
  background-color: #D1E6F5;
}

.tableContent {
  width: 30%;
  text-align: left;
  white-space: pre-wrap;
}
</style>
